import { axios } from 'shared/services/axios'

export function fetchArticles() {
  return axios.get('/api/v1/articles')
}

export function fetchArticle({ articleId, authorizationParams }) {
  return axios.get(`/api/v1/articles/${articleId}`, { params: authorizationParams })
    .then(response => response.data)
}

export function createArticle({ authorizationParams }) {
  return axios.post('/api/v1/articles', authorizationParams)
    .then(response => response.data)
}

export function updateArticle({ articleId, data, authorizationParams }) {
  return axios.put(`/api/v1/articles/${articleId}`, {
    ...data,
    ...authorizationParams
  })
    .then(response => response.data)
}

export function createImage({ articleId, image, authorizationParams }) {
  return axios.post(`/api/v1/articles/${articleId}/image`, {
    ...image,
    ...authorizationParams
  })
  .then(response => response.data)
}

export function publishArticle({ articleId, data, authorizationParams }) {
  return axios.put(`/api/v1/articles/${articleId}/publish`, {
    data,
    ...authorizationParams
  })
  .then(response => response.data)
}

export function revertArticle({ articleId, toStatus, authorizationParams, data = {} }) {
  return axios.put(`/api/v1/articles/${articleId}/revert`, {
    to_status: toStatus,
    data,
    ...authorizationParams
  })
  .then(response => response.data)
}
